import { Component } from '@angular/core';

@Component({
  selector: 'app-bobby-calves-outage',
  templateUrl: './bobby-calves-outage.component.html',
  styleUrls: ['./bobby-calves-outage.component.scss'],
})
export class BobbyCalvesOutageComponent {}
